// extracted by mini-css-extract-plugin
module.exports = {"oversiktSearch":"OversiktTextFilter_oversiktSearch__voJAD"};